import {AlpineComponent} from 'alpinejs';

type AjaxSpinner = {
  isLoading: boolean
}

export default (): AlpineComponent<AjaxSpinner> => ({
  isLoading: false,
  init() {
    document.documentElement.addEventListener('ajax:after', () => {
      this.isLoading = false;
    });
    document.documentElement.addEventListener('ajax:before', () => {
      this.isLoading = true;
    });
  }
});